// extracted by mini-css-extract-plugin
export default {"root":"UI3rt34L3BZFxiD4VQsf"};